"use strict";

const $ = require("jquery");

class DropdownFilters {
    constructor() {
        //Remove filter error text if user selects other filter items
        $(".ce-dropdown-filters select").on("change", function () {
            $(".ce-dropdown-filters .validation-error").remove();
        });

        $(".ce-dropdown-filters .submit").on("click", function (e) {
            var region = $(".region").children("option:selected").val();
            region = region.replace(/\s+/g, '-').toLowerCase();
            var year = $(".year").children("option:selected").val();
            year = year.replace(/\s+/g, '-').toLowerCase();

            if(region.length > 0 && year.length > 0) {
                // Make an AJAX request to fetch a post based on selected terms
                $.ajax({
                    url: "/wp/wp-admin/admin-ajax.php",
                    type: "POST",
                    data: {
                        action: "filter_posts",
                        region: region,
                        year: year
                    },
                    success: function(response) {
                        //Redirect to post page if it isn't empty or a 404, else return error
                        if (response.trim() !== 'No posts found' && response.trim() !== '') {
                            document.location.href = response;
                        } else {
                            if(!$(".ce-dropdown-filters .column").find('.validation-error').length) {
                                $(".ce-dropdown-filters .column").append("<p class='validation-error'>Er is geen jaarverslag gevonden met deze filters. Probeer een ander jaartal of regio.</p>");
                            }
                        }
                    },
                    error: function(error) {
                        console.error("Error fetching post:", error);
                    }
                });
            } else {
                $(".ce-dropdown-filters .column").append("<p class='validation-error'>Er is geen jaar of regio geselecteerd. Controleer of beide filters zijn geselecteerd en probeer het opnieuw.</p>");
            }
            e.preventDefault();
        });

        $('.ce-dropdown-filters .submit').addClass('button yellow with-icon icon-right arrow-right');
    }
}

module.exports = DropdownFilters;
